var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"item",style:(_vm.config.linkStyle? _vm.config.linkStyle : {})},[_c('span',{on:{"click":function($event){return _vm.config.click(_vm.formParam)}}},[_vm._v(_vm._s(_vm.itemData))])])}
var staticRenderFns = []

export { render, staticRenderFns }